import type {
  InventoryItem,
  ModifiedData,
} from 'app/components/pages/Extranet/ExtranetInventory/Modern/InventoryStore';
import type {
  InventoryDatePacks,
  InventoryPacksForm,
} from 'app/typings/core/extranet/inventory/form/inventoryForm';

export const mapToPackResponse = (packs: ModifiedData): InventoryPacksForm => {
  const result: InventoryPacksForm = {};

  Object.entries(packs || {}).forEach(([dateKey, items]) => {
    if (!items || typeof items !== 'object') {
      return;
    }

    const dateEntry: InventoryDatePacks = {
      packs: {},
    };

    Object.entries(items).forEach(([itemId, itemData]) => {
      if (!itemData || typeof itemData !== 'object') {
        return;
      }

      const maxBooking = (itemData as InventoryItem).maxBooking;

      const parsed =
        maxBooking === null || maxBooking === undefined
          ? null
          : typeof maxBooking === 'number'
            ? maxBooking
            : Number(maxBooking);

      if (parsed === null || !Number.isNaN(parsed)) {
        dateEntry.packs[Number(itemId)] = { maxBooking: parsed };
      }
    });

    if (Object.keys(dateEntry.packs).length > 0) {
      result[dateKey] = dateEntry;
    }
  });

  return result;
};
